     <!-- 4.- Fila con 6 imagenes -->
                
     <div class="brook-footer-area plr--100 plr_lg--30 plr_md--30 plr_sm--30 rslide" data-background="#ff7e43" style="background-color:#ff7e43; padding: 40px 0px;">
        <div class="footer-top">
            <div class="brook-section-title  mb--90 text-center">
                <div class="revulutionlink">
                    <h3 class="heading heading-h3 font-40 text-white">ÚNETE A NUESTRA COMUNIDAD</h3>
                </div>
            </div>
        </div>
        <div class="bk-intagram-list instagram-grid">
            <div class="instagram-grid-wrap instagram-grid-5 move-up wow">
                <!-- Imagen 1 -->
                <div class="item-grid grid-style--1">
                    <div class="thumb">
                        <a href="#">
                            <img src="assets/img/galeria/foto-1.jpg" alt="Escuela Akashica">
                        </a>
                        <div class="item-info">
                            <div class="inner">
                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                            </div>
                        </div>
                    </div>
                </div>
                

                <!-- Imagen 2 -->
                <div class="item-grid grid-style--1">
                    <div class="thumb">
                        <a href="#">
                            <img src="assets/img/galeria/foto-2.jpg" alt="Escuela Akashica">
                        </a>
                        <div class="item-info">
                            <div class="inner">
                                <a href="#"><i class="fas fa-heart"></i>4k</a>
                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                            </div>
                        </div>
                    </div>
                </div>
              

                <!-- Imagen 3 -->
                <div class="item-grid grid-style--1">
                    <div class="thumb">
                        <a href="#">
                            <img src="assets/img/galeria/foto-3.jpg" alt="Escuela Akashica">
                        </a>
                        <div class="item-info">
                            <div class="inner">
                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                            </div>
                        </div>
                    </div>
                </div>
                

                <!-- Imagen 4 -->
                <div class="item-grid grid-style--1">
                    <div class="thumb">
                        <a href="#">
                            <img src="assets/img/galeria/foto-4.jpg" alt="Escuela Akashica">
                        </a>
                        <div class="item-info">
                            <div class="inner">
                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                            </div>
                        </div>
                    </div>
                </div>
               

                <!-- Imagen 5 -->
                <div class="item-grid grid-style--1">
                    <div class="thumb">
                        <a href="#">
                            <img src="assets/img/galeria/foto-5.jpg" alt="Escuela Akashica">
                        </a>
                        <div class="item-info">
                            <div class="inner">
                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Imagen 6 -->
                <div class="item-grid grid-style--1">
                    <div class="thumb">
                        <a href="#">
                            <img src="assets/img/galeria/foto-5.jpg" alt="Escuela Akashica">
                        </a>
                        <div class="item-info">
                            <div class="inner">
                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Start Single Instagram -->

            </div>
        </div>

       

    </div>

